import { computed, unref } from 'vue'

export const useCarouselItems = async (
  carouselId,
  {
    key,
    query = {},
    defaultValue = [],
    watch = [],
    immediate = true
  } = {}
) => {
  if (!key) {
    throw new Error('useCarouselItems requires a unique `key` option for useAsyncData.')
  }

  const { API_ENDPOINTS } = useApiEndpoints()

  const idRef = computed(() => unref(carouselId))
  const queryRef = computed(() => unref(query) || {})

  const fetchItems = async () => {
    const id = idRef.value
    if (!id) {
      return []
    }

    const requestOptions = {}
    if (Object.keys(queryRef.value).length) {
      requestOptions.query = queryRef.value
    }

    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.public.carousels.items(id),
      requestOptions
    )

    return Array.isArray(response?.data) ? response.data : []
  }

  const watchSources = [idRef, queryRef, ...watch]

  const { data, pending, refresh } = await useAsyncData(
    key,
    fetchItems,
    {
      default: () => defaultValue,
      watch: watchSources,
      immediate: immediate && !!idRef.value
    }
  )

  return {
    items: computed(() => data.value ?? defaultValue),
    pending,
    refresh
  }
}
